import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MerchantGraphsComponent } from '../merchant-graphs/merchant-graphs.component';
import { IdTextPair } from '../../models/id-text-pair';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MerchantViewBillingComponent } from '../merchant-view-billing/merchant-view-billing.component';
import { BillingDate } from '../../models/merchant-billing-models/billing-date';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { DatePipe } from '@angular/common';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { Router } from '@angular/router';
import { MerchantBillingRolesService } from '../../services/merchant-billing-roles.service';
import { MerchantBillingRoles } from '../../models/merchant-billing-models/merchant-billing-roles';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard-base.component.html',
  styleUrls: ['./dashboard-base.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  public currentDashboard: string = 'default';
  public isChatGraphs: string = 'default';
  isVisible: boolean = false;
  isAlreadyOpen: string | null = null;
  hasMerchantBillingChanged = false;
  public reloadGraphs: boolean = true;
  public hasBillingReport: boolean = false;
  public merchantBillingNames: IdTextPair[] = [];
  public merchantBillingDates: IdTextPair[] = [];
  public selectedMerchantBillingDate: string = '';
  public selectedMerchantBillingName: string = '';
  public participantId: Number = 0;
  selectedDate: string | undefined;
  setBillingDate: BillingDate = { id: 0, dates: '' };
  @ViewChild(MerchantGraphsComponent) private _merchantGraphsComponent: MerchantGraphsComponent;
  public canViewParticipantDashboard: boolean = false;

  constructor(
    private _modalService: NgbModal,
    private datePipe: DatePipe,
    private userDataStore: UserDataStoreService,
    private merchantBillingRolesService: MerchantBillingRolesService,
    private router: Router
  ) {}

  ngOnInit() {
    var selectedParticipantSubject = new BehaviorSubject<ParticipantViewModel>(JSON.parse(localStorage.getItem('selectedParticipant')));
    this.participantId = Number(selectedParticipantSubject.value.id.toString());
    this.setBillingDate.id = Number(selectedParticipantSubject.value.id.toString());
    this.userMerchantBillingRole();
  }

  public async userMerchantBillingRole() {
    const _merchantBillingRole: MerchantBillingRoles = await this.merchantBillingRolesService.GetById(this.userDataStore.currentUserValue.id);
    if (_merchantBillingRole !=null) {
       this.canViewParticipantDashboard = true;
    }
  }

  receiveValue(value: any): void {
    if (value.merchantBillingNames && this.isVisible) {
      this.merchantBillingNames = value.merchantBillingNames;
      this.merchantBillingDates = value.merchantBillingDates;
      this.selectedMerchantBillingName = value.merchantBillingNames[0].id;
      this.selectedMerchantBillingDate = value.merchantBillingDates[0].id;
    }
  }

  handleBillingReportAvailability(hasReport: boolean): void {
    this.hasBillingReport = hasReport;
    if (hasReport) {
      this.currentDashboard = 'chatgraphs';
      this.isVisible = true;
    } else {
      this.currentDashboard = 'default';
      this.isVisible = false;
    }
  }

  reloadMerchantGraphs(): void {
    this.reloadGraphs = false;
    setTimeout(() => this.reloadGraphs = true, 0);
  }

  showDashboard(dashboard: string): void {
    if (this.isAlreadyOpen === dashboard) {
      return;
    }

    this.hasBillingReport = false;
    this.isAlreadyOpen = dashboard;
    if (dashboard === 'chatgraphs') {
      this.hasMerchantBillingChanged = false;
      this.isChatGraphs = 'chatgraphs';
    }
    else {
      this.currentDashboard = dashboard;
      this.isChatGraphs = dashboard;
      this.isVisible = false;
      this.merchantBillingDates = [];
      this.merchantBillingNames = [];
      this._merchantGraphsComponent.getBillingDate.dates = '';
      this.setBillingDate.id = Number(this.participantId);
    }
  }

  public async onMerchantbillingChange(selectedValue: string): Promise<void> {
    if (selectedValue) {
      this.setBillingDate.dates = this.selectedDate
      this._merchantGraphsComponent.receiveData(Number(this.setBillingDate.id), this.selectedDate);
    }
  }

  onSelectedMerchantBilling(selectedValue: string): void {
    this.setBillingDate.id = Number(this.merchantBillingNames.find(x => x.id == "" + selectedValue).id);
    if (!this.hasMerchantBillingChanged) {
      this.hasMerchantBillingChanged = true;
      this.selectedDate = '';
    }
    this._merchantGraphsComponent.loadMerchantBillingReports(this.setBillingDate.id, this.selectedDate);
  }

  onSelectedMerchantBillingByDate(selectedValue: string): void {
    const dateEntry = this.merchantBillingDates.find(x => x.id === selectedValue);
    this.selectedDate = this.formatDate(dateEntry.text);
    this.setBillingDate.dates = this.selectedDate
    if (this.hasMerchantBillingChanged) {
      this.hasMerchantBillingChanged = false;
      return
    }
    this._merchantGraphsComponent.loadMerchantBillingReports(this.setBillingDate.id, this.selectedDate);
  }

  public async onMerchantbillingChangeByDate(selectedValue: string): Promise<void> {
    if (selectedValue) {
      const dateEntry = this.merchantBillingDates.find(x => x.id === selectedValue);
      this.selectedDate = this.formatDate(dateEntry.text);
      this._merchantGraphsComponent.receiveData(Number(this.setBillingDate.id), this.selectedDate);
    }
  }

  private formatDate(dateText: string): string {
    return dateText !== '' ? dateText.split('to')[0].trim() : dateText;
  }

  viewDataTable(): void {
    const dialogRef = this._modalService.open(MerchantViewBillingComponent, {
      windowClass: 'modal-fade-in custom-modal-dialog',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });

    const sortedReports = this._merchantGraphsComponent.merchantBillingData.merchantBillingReports.sort((a, b) => {
      return parseFloat(b.value) - parseFloat(a.value);
    });

    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = sortedReports.length > 0 ? `${sortedReports[0].client} report` : "Merchant billing report";
    dialogRef.componentInstance.merchantBillReports = sortedReports;
    dialogRef.componentInstance.merchantBillingId = this.setBillingDate.id;
    dialogRef.componentInstance.date = this.selectedDate;

    if (this.selectedDate === undefined) {
      var _dateStart = this._merchantGraphsComponent.merchantBillingData.merchantBillingTopTransaction[0].dateStart;
      dialogRef.componentInstance.date = this.datePipe.transform(new Date(_dateStart.toString()), 'yyyy-MM-dd');
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
